export { Heading } from './Heading';
export * from './Heading.types';
export { APPEARANCES, SIZE } from './Heading.constants';
